<template>
  <div>
    <el-input
      v-if="readonly"
      :id="id"
      :disabled="disabled"
      :value="config[configName + '_empty'] ? '' : '******'"
      type="password"
      @click.native="tryToChangePasswd()"
      @input="tryToChangePasswd()"
      @focus="tryToChangePasswd()"
    />
    <el-input v-model="autoComplete" v-show="false" show-password auto-complete="new-password" />
    <el-input
      v-if="!readonly"
      :id="id"
      ref="passwd"
	  type="password"
      v-model="config[configName]"
      :maxlength="maxlength"
      :disabled="disabled"
      auto-complete="new-password"
      @input="update"
    />
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    configName: {
      type: String,
      default: "password",
    },
    config: {
      type: Object,
      default() {},
    },
    maxlength: {
      type: Number,
      default: 64,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoComplete: "",
      readonly: true,
    };
  },
  methods: {
    tryToChangePasswd() {
      if (this.disabled) {
        return;
      }
      this.readonly = false;
      this.update();
      setTimeout(
        function () {
          this.$refs.passwd.focus();
        }.bind(this),
        1,
      );
    },
    update() {
      if (!this.readonly) {
        this.config[this.configName + "_changed"] = 1;
      }
    },
  },
};
</script>
